import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const asana = defineConnector({
  identifier: "asana",
  name: "Asana",
  tagLine: "Work management platform",
  logo,
  protocol: "http",
  tags: ["featured", "productivity"],
  defaultUrlPattern: () => "https://app\\.asana\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Asana Developer Console](https://app.asana.com/0/my-apps) and create a new personal access token under **My apps**.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Asana personal access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.asana.com/api/1.0/users/me",
  },
});
